const prefix = process.env.VUE_APP_API_DATAS;

export default ({ request }) => ({
  // 首页弹窗内容
  riskStatement(params = {}) {
    return request({
      url: `${prefix}/riskStatement`,
      method: "get",
      params,
    });
  },
  // 首页banner图
  indexBanner(params) {
    return request({
      url: `${prefix}/indexBanner`,
      method: "get",
      params,
    });
  },
  // 首页相关
  indexAbout(params) {
    return request({
      url: `${prefix}/indexAbout`,
      method: "get",
      params,
    });
  },
  // 首页公司介绍
  indexCompanyIntroduce(params) {
    return request({
      url: `${prefix}/indexCompanyIntroduce`,
      method: "get",
      params,
    });
  },
  // 菜单数据
  menus(params) {
    return request({
      url: `${prefix}/menus`,
      method: "get",
      params,
    });
  },
  // 动态数据
  companyDynamics(params) {
    return request({
      url: `${prefix}/companyDynamics`,
      method: "get",
      params,
    });
  },
  // 首页指定长度的新闻数据
  indexNews(params) {
    return request({
      url: `${prefix}/indexNews`,
      method: "get",
      params,
    });
  },
  // 行业资讯
  industryNews(params) {
    return request({
      url: `${prefix}/industryNews`,
      method: "get",
      params,
    });
  },
  // 公司公告
  companyAnnouncement(params) {
    return request({
      url: `${prefix}/companyAnnouncement`,
      method: "get",
      params,
    });
  },
  // 风险声明
  // riskStatement(params) {
  //   return request({
  //     url: `${prefix}/riskStatement`,
  //     method: "get",
  //     params,
  //   });
  // },
  // 合格投资者认证
  accreditedInvestorCertification(params) {
    return request({
      url: `${prefix}/accreditedInvestorCertification`,
      method: "get",
      params,
    });
  },
  // 合格投资者认证 - 提示
  accreditedInvestorCertificationPrompt(params) {
    return request({
      url: `${prefix}/accreditedInvestorCertificationPrompt`,
      method: "get",
      params,
    });
  },
  // 获取新闻数据
  newsData(params) {
    return request({
      url: `${prefix}/news`,
      method: "get",
      params,
    });
  },
  // 获取新闻列表所有数据
  allNewsDatas(params) {
    return request({
      url: `${prefix}/allNewsDatas`,
      method: "get",
      params,
    });
  },
  // 搜索新闻列表所有数据
  search(params) {
    return request({
      url: `${prefix}/search`,
      method: "get",
      params,
    });
  },
});
